export enum NetworkingFillStatus {
  /**
   * Не заполнены обязательные поля основного профиля:
   * - email
   * - firstName
   * - lastName
   * - position
   * - country
   * - city
   * - employmentType
   *
   * Для EmploymentType::TYPE_1 дополнительно проверяются:
   * - companyTypes (хотя бы один)
   * - workName
   */
  IncompleteProfile = 0,

  /**
   * Обязательные поля профиля заполнены, но не хватает данных для нетворкинга:
   * - interestCompanyTypes (хотя бы один)
   * - languages (хотя бы один)
   */
  MissingNetworkingData = 1,

  /**
   * Для EmploymentType::TYPE_1 требуется привязка к компании
   */
  NeedCompanyAssociation = 2,

  /**
   * Все обязательные поля заполнены
   */
  Complete = 3,
}
